import { render, staticRenderFns } from "./projectCPCombinedCard.vue?vue&type=template&id=3d7e63ba&scoped=true"
import script from "./projectCPCombinedCard.vue?vue&type=script&lang=js"
export * from "./projectCPCombinedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e63ba",
  null
  
)

export default component.exports